// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFoundPage_wrapper__3Bth0","title":"NotFoundPage_title__1oKuB","subTitle":"NotFoundPage_subTitle__2Etlj"};